import SidebarLabel from "@/modules/SidebarLabel.vue";
import AppTimeline from "@/@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import ModalBoxAddBill from "./components/ModalBoxAddBill.vue";
import WidgetDateTime from "../../../ultils/Form/components/DateTime/WidgetDatetime.vue";
import PaymentForDistribution from "../../../ultils/PaymentForm/PaymentForDistribution.vue";
import EzTable from "../../../ultils/Table/EzTable.vue";
import PermissionButton from "../../../ultils/Button/PermissionButton.vue";
import GeneralInfo from "../../../ultils/General/GeneralInfo.vue";
import {
  convertArPaymentStatus,
  convertArPaymentDistributionStatus,
  convertTransactionType
} from "@/views/modules/ultils/status";
import { arClient } from "@/api/ar-client";
import { AR_DPAD01, AR_RPAD01,AR_IPAD01,AR_UPA01 ,AR_HSP01,AR_UPAD01} from "@/api/constant";
export default {
  components: {
    PermissionButton,
    GeneralInfo,
    EzTable,
    SidebarLabel,
    PaymentForDistribution,
    ModalBoxAddBill,
    AppTimeline,
    WidgetDateTime,
    AppTimelineItem,
  },
  props: {
    isUpdate: Boolean,
    detailRowIndex: Number,
    isDetailPaymentLoading: Boolean,
    /*    listPaymentHistory: {
      type: Array,
      default() {
        return [];
      },
    }, */
    isShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      nullable: true,
      default: () => {
        return null;
      },
    },
    dataRefillForBill: {
      type: Object,
      nullable: true,
      default: () => {
        return null;
      },
    },
    listDataCashier: {
      type: Array,
      default: () => {
        return [];
      },
    },
    listPayment: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup(){
    return {convertTransactionType,AR_IPAD01,AR_UPA01,AR_HSP01,AR_UPAD01}
  },
  data() {
    return {
      isUpdatingPayment: false,
      listPaymentHistory: [],
      isShowModalPayment: false,
      range: null,
      actions: [
        {
          apiCode:AR_RPAD01,
          title: "ar_common_detail",
          icon: "eye",
        },
        {
          apiCode:AR_DPAD01,
          danger: true,
          icon: "trash",
          title: "ar_common_delete",
        },
      ],
      columns: [
        {
          caption: "ar_client_payment_date",
          field: "CreatedDate",
          cellTemplate: true,
          formatType: "date",
        },
        {
          caption: "ar_client_cashier",
          field: "CashierName",
          cellTemplate: true,
          cellRender(data) {
            return `${data.data.CashierCode} - ${data.data.CashierName}`;
          },
        },
        {
          caption: "ar_client_payment_type",
          field: "PaymentDetailType",
          cellTemplate: true,
          align: "center",
          cellRender(data) {
            return "Thanh toán";
          },
        },
        {
          caption: "ar_client_payments",
          field: "PaymentMethodName",
        },
        {
          caption: "ar_client_amount",
          field: "Amount",
          cellTemplate: true,
          formatType: "num",
        },
        {
          caption: "ar_client_currency_code",
          field: "CurrencyFomart",
        },
      ],
      tabIndex: 0,
      userData: JSON.parse(localStorage.getItem("userData")),
      currentShow: 20,

      FromDate: null,
      isShowAddNewBill: false,
      refillDataBill: null,
    };
  },
  methods: {
    
    async fetchPaymentHistory(data) {
      await this.arClient.api_AR_HSP01({ ...data, ArPaymentId: this.data.Id }).then((res) => {
        if (res.Status !== "200") {
          this.showResToast(res);
          return;
        }

        this.listPaymentHistory = res.Data.ArTransaction;
      });
    },
    convertArPaymentDistributionStatus(title) {
      return convertArPaymentDistributionStatus(title);
    },
    convertArPaymentStatus(title) {
      return convertArPaymentStatus(title);
    },
    convertedTransaction(type) {
      let status = "primary";
      if (type.startsWith("Thanh toán")) {
        status = "success";
      }
      if (type.startsWith("Xóa")) {
        status = "danger";
      }
      return status;
    },
    showMoreHistory() {
      this.currentShow += 20;
    },
    closeSidebar() {
      this.$emit("update:isShow", false);
    },
    showModalEditAddNew() {
      this.$emit("show-edit", this.data);
    },
    acceptDataSaveForBill(value) {
      this.$emit("accept-data-bill", value);
    },
    showModalAddNew() {
      this.$emit("update:dataRefillForBill", null);
      /*   this.isShowModalPayment = true */
      this.$root.$emit("bv::show::modal", "modal-payment-for-distribution");
    },

    delListArPayment(ArPaymentCode, Id) {
      const deleteDialogRef = this.$parent.$parent.$refs.tableRate.$refs.deleteDialog[0];

      deleteDialogRef.open({
        data: { ArPaymentCode, Id },
      });

      /*  this.$emit("del-arpayment", {
        ArPayment: {
          Id: id,
        },
      }); */
    },
    editListPaymentAr(id) {
      this.$emit("show-edit-bill", id);
      this.$root.$emit("bv::show::modal", "modal-payment-for-distribution");
      /* this.isShowModalPayment = true */
    },
    acceptDataEditForBill(data) {
      this.$emit("accept-data-edit", data);
    },
  },
  created() {},
  computed: {
    convertedListArPaymentDetail() {
      return this.data.ListArPaymentDetail;
    },
    limitedListPaymentHistory() {
      return this.listPaymentHistory.slice(0, this.currentShow);
    },
    listGeneral() {
      return [
        {
          icon: "code",
          label: "ar_client_payment_code",
          content: this.data.PaymentCode,
        },
        {
          icon: "bar-chart",
          label: "ar_client_receipt_status",
          variant: this.$t(convertArPaymentStatus(this.data.PaymentStatus).variant),
          content: this.$t(convertArPaymentStatus(this.data.PaymentStatus).title),
        },
        {
          icon: "place",
          label: "ar_voucher_company_name",
          content: this.data.ArTravelAgentName,
        },
        {
          icon: "bar-chart-2",
          label: "ar_client_allotment_states",
          content: this.$t(convertArPaymentDistributionStatus(this.data.DistributionStatus).title),
          variant: this.$t(
            convertArPaymentDistributionStatus(this.data.DistributionStatus).variant
          ),
        },
        {
          icon: "user",
          label: "ar_client_payer",
          content: this.data.Payer,
        },
        {
          icon: "dollar-sign",
          label: "ar_client_exchange_amount",
          afterFixLabel: "(VND)",
          content: this.formatPrice(this.data.TotalAmount),
        },
        {
          icon: "calendar",
          label: "ar_client_payment_date",
          content: this.formatDate(this.data.PaymentDate),
        },
        {
          icon: "plus-circle",
          label: "ar_client_distribution_value",
          afterFixLabel: "(VND)",
          content: this.formatPrice(this.data.DistributionAmount),
        },
        {
          icon: "user",
          label: "ar_client_created_person",
          content: this.data.CashierName,
        },
        {
          icon: "file-text",
          label: "ar_client_account_note",
          top: true,
          content: this.data.Note,
        },
        {
          icon: "calendar",
          label: "ar_voucher_create_date",
          content: this.formatDate(this.data.CreatedDate),
        },
      ];
    },
  },
  watch: {
    data: {
      handler(v) {
        if (v) {
          this.fetchPaymentHistory();
        }
      },
      deep: true,
    },
    isShow(value) {
      this.$emit("update:isShow", value);
      if (!value) this.tabIndex = 0;
    },
  },
};
